<template>
	<v-container fluid >
		  <v-dialog v-model="questionnairePopupShow" :persistent="true" max-width="715">
			<v-card>
				<v-card-text>
					<v-layout row wrap pt-3 pl-1>
							<v-flex md5 xs12>
								<InputField
									v-if="questionnairePopupShow"
									v-model="questionnaire.name"
									:error="questionnaireValidation.name"
									:label="'* '+$t('fields.name')"></InputField>
							</v-flex>
							<v-flex md5 xs12 offset-md1>
								<Dropdown
									v-model="questionnaire.realestate_type"
									:error="questionnaireValidation.realestate_type"
									:ajax="true"
									:data="'opportunity-features/realestate_type'"
									:label="'* '+$t('fields.realestateType')"
									></Dropdown>
							</v-flex>
							<v-flex md5 xs12>
								<InputField
									v-if="questionnairePopupShow"
									v-model="questionnaire.rooms_no"
									:mask="'###'"
									:error="questionnaireValidation.rooms_no"
									:label="$t('fields.roomsNo')"></InputField>
							</v-flex>
							<v-flex md5 xs12>
							</v-flex>
							<v-flex md5 xs12>
								<InputField
									v-if="questionnairePopupShow"
									v-model="questionnaire.price_from"
									:error="questionnaireValidation.price_from"
									:mask="'##########'"
									:label="$t('fields.priceFrom')"></InputField>
							</v-flex>
							<v-flex md5 xs12 offset-md1>
								<InputField
									v-if="questionnairePopupShow"
									v-model="questionnaire.price_to"
									:mask="'##########'"
									:error="questionnaireValidation.price_to"
									:label="$t('fields.priceTo')"></InputField>
							</v-flex>
							<v-flex md5 xs12>
								<InputField
									v-if="questionnairePopupShow"
									v-model="questionnaire.area_from"
									:error="questionnaireValidation.area_from"
									:mask="'##########'"
									:label="$t('fields.areaFrom')"></InputField>
							</v-flex>
							<v-flex md5 xs12 offset-md1>
								<InputField
									v-if="questionnairePopupShow"
									v-model="questionnaire.area_to"
									:error="questionnaireValidation.area_to"
									:mask="'##########'"
									:label="$t('fields.areaTo')"></InputField>
							</v-flex>
							<br>
							<v-flex md5 xs12>
								<div>
								<DropdownMultiple
									v-model="questionnaire.neighbourhoods"
									:ajax="true"
									:data="'neighbourhoods'"
									:label="$t('fields.neighbourhood')"></DropdownMultiple>
								</div>
							</v-flex>
							<v-flex xs12>
								<div>
								<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.location')}}</span>
									<v-radio-group v-model="questionnaire.sea_selection" row class="ma-0 pt-1" hide-details>
										<v-radio :label="$t('fields.sea1st')" :value="1"></v-radio>
										<v-radio :label="$t('fields.sea2nd')" :value="2"></v-radio>
										<v-radio :label="$t('fields.seaBoth')" :value="3"></v-radio>
										<v-radio :label="$t('fields.seaNone')" :value="4"></v-radio>
									</v-radio-group>
								</div>
							</v-flex>
							<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.additional_info')}}</span>
							<v-flex xs12>
								<CheckBox
									:label="$t('fields.seaView')"
									v-model="questionnaire.sea_view"
									:simple="true"></CheckBox>
							</v-flex>
							<v-flex xs12>
								<CheckBox
									:label="$t('fields.elevator')"
									v-model="questionnaire.elevator"
									:simple="true"></CheckBox>
							</v-flex>
							<v-flex xs12>
								<CheckBox
									:label="$t('fields.garden')"
									v-model="questionnaire.garden"
									:simple="true"></CheckBox>
							</v-flex>
							<v-flex xs12>
								<CheckBox
									:label="$t('fields.pool')"
									v-model="questionnaire.pool"
									:simple="true"></CheckBox>
							</v-flex>
							<v-flex xs12 pt-4 pb-2>
								<CheckBox
									:label="$t('fields.active')"
									v-model="questionnaire.active"
									:simple="true"></CheckBox>
							</v-flex>
						</v-layout>
				</v-card-text>
				<v-card-actions>
					<v-tooltip top v-if="changesHappened == true">
						<v-btn class="button" slot="activator" color="grey">{{ $t('buttons.match') }}</v-btn>
						<span>{{ $t('tooltips.saveBeforeMatch') }}</span>
					</v-tooltip>
					<v-btn v-if="changesHappened == false" class="button" dark @click="match">{{ $t('buttons.match') }}</v-btn>
					<v-spacer></v-spacer>
					<v-btn class="button" dark @click="cancelQuestionnairePopup">{{ $t('buttons.cancel') }}</v-btn>
					<v-btn class="button" dark @click="questionnaireSaveClick">{{ $t('buttons.ok') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-layout row wrap v-if="results == false">
			<v-flex sm8 md4 xs12 offset-sm2 offset-md4>
				<v-card class="pa-4">
					<v-card-text class="grey--text">
						<v-flex xs12>
							nema rezultata
						</v-flex>
						<v-layout text-xs-right>
						<v-flex xs12>
							<v-btn @click="back" color="grey lighten-1">{{$t('buttons.back')}}
							</v-btn>
						</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs1 text-xs-right v-if="results == true">
				<a :href="vtigerObject.contact.vtiger_link" target="_blank">
					<v-btn>
						<v-icon small>fa-external-link-alt</v-icon>&nbsp;{{ $t('buttons.vtigerLink') }}
					</v-btn>
				</a>
			</v-flex>
			<v-flex xs11 text-xs-right v-if="results == true">
				<v-btn @click="back">
				    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
			    </v-btn>
				<v-btn @click="save">
				    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
			    </v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap v-if="results == true">
			<v-flex xs12>
			<v-tabs color="#fafafa" v-model="tabId">
				<v-tab>{{ $t('tabs.questionnaires') }}</v-tab>
				<v-tab>{{ $t('tabs.details') }}</v-tab>
				<v-tab-item>
					<v-flex xs1 text-xs-right v-if="results == true">
							<v-btn class="ml-0" color="success" @click="questionnaireAddClick">
								<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
							</v-btn>
					</v-flex>
					<DataTable
						:excel="false"
						:headers="questionnairesTable.headers"
						:items="questionnairesTable.items"
						:total="questionnairesTable.total"
					>
						<template #row="props">
							<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
								<td @click="questionnaireEditClick(props.item.id, false)">{{ props.item.name }}</td>
								<td @click="questionnaireEditClick(props.item.id, false)">{{ props.item.realestate_type }}</td>
								<td @click="questionnaireEditClick(props.item.id, false)">{{ props.item.rooms_no }}</td>
								<td @click="questionnaireEditClick(props.item.id, false)">{{ props.item.price_from_display }}</td>
								<td @click="questionnaireEditClick(props.item.id, false)">{{ props.item.price_to_display }}</td>
								<td @click="questionnaireEditClick(props.item.id, false)">{{ props.item.area_from }}</td>
								<td @click="questionnaireEditClick(props.item.id, false)">{{ props.item.area_to }}</td>
								<td @click="questionnaireEditClick(props.item.id, false)">
									<v-icon small v-if="props.item.sea_1st">fa-check</v-icon>
								</td>
								<td @click="questionnaireEditClick(props.item.id, false)">
									<v-icon small v-if="props.item.sea_2nd">fa-check</v-icon>
								</td>
								<td @click="questionnaireEditClick(props.item.id, false)">
									<v-icon small v-if="props.item.sea_view">fa-check</v-icon>
								</td>
								<td @click="questionnaireEditClick(props.item.id, false)">
									<v-icon small v-if="props.item.elevator">fa-check</v-icon>
								</td>
								<td @click="questionnaireEditClick(props.item.id, false)">
									<v-icon small v-if="props.item.garden">fa-check</v-icon>
								</td>
								<td @click="questionnaireEditClick(props.item.id, false)">
									<v-icon small v-if="props.item.pool">fa-check</v-icon>
								</td>
							</tr>
						</template>
					</DataTable>
				</v-tab-item>
				<v-tab-item>
					<v-flex md5 xs12>
						<Dropdown
							v-model="contact.partner_id"
							:ajax="true"
							:data="'partners'"
							:label="$t('fields.partner')"
						></Dropdown>
					</v-flex>
				</v-tab-item>
			</v-tabs>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import Contact from "../models/Contact";
import CheckBox from "./trinkets/CheckBox";
import Dropdown from "./trinkets/Dropdown";
import DropdownMultiple from "./trinkets/DropdownMultiple";
import DataTable from './trinkets/DataTable';
import InputField from "./trinkets/InputField";
import QuantityField from './trinkets/QuantityField';
import CurrencyField from './trinkets/CurrencyField.vue';

	export default {
		name: 'App',
		components: {CheckBox, InputField, Dropdown, CurrencyField, DataTable, QuantityField, DropdownMultiple},
		data() {
			return {
				questionnairesTable:{
					headers: [
					{text: this.$t('fields.name'), value: 'name', type: 'string', searchable: false, sortable: false},
					{text: this.$t('fields.realestateType'), value: 'realestate_type', type: 'string', searchable: false, sortable: false},
					{text: this.$t('fields.roomsNo'), value: 'rooms_no', type: 'string', searchable: false, sortable: false},
					{text: this.$t('fields.priceFrom'), value: 'price_from', type: 'string', searchable: false, sortable: false},
					{text: this.$t('fields.priceTo'), value: 'price_to', type: 'string', searchable: false, sortable: false},
					{text: this.$t('fields.areaFrom'), value: 'area_from', type: 'string', searchable: false, sortable: false},
					{text: this.$t('fields.areaTo'), value: 'area_to', type: 'string', searchable: false, sortable: false},
					{text: this.$t('fields.sea1st'), value: 'sea_1st', type: 'boolean_yes', searchable: false, sortable: false},
					{text: this.$t('fields.sea2nd'), value: 'sea_2nd', type: 'boolean_yes', searchable: false, sortable: false},
					{text: this.$t('fields.seaView'), value: 'sea_view', type: 'boolean_yes', searchable: false, sortable: false},
					{text: this.$t('fields.elevator'), value: 'elevator', type: 'boolean_yes', searchable: false, sortable: false},
					{text: this.$t('fields.garden'), value: 'garden', type: 'boolean_yes', searchable: false, sortable: false},
					{text: this.$t('fields.pool'), value: 'pool', type: 'boolean_yes', searchable: false, sortable: false},
					],
					items: [],
					total: 0,
					lastRequest: null
				},
				tabId: 0,
				results: null,
				initialLoad: false,
				initialLoadQuestionnaire: false,
				changesHappened: false,
				publicPath: process.env.BASE_URL,
				contact: new Contact({}),
				partners: [],
				questionnaireShow: false,
				vtigerObject: '',
				index: 0,
				contactCategory: null,
				questionnairePopupShow: false,
				questionnaire: {
					id: 0,
					name: '',
					realestate_type: null,
					contact_id: '',
					rooms_no: null,
					price_from: null,
					price_to: null,
					area_from: null,
					area_to: null,
					sea_1st: false,
					sea_2nd: false,
					sea_view: false,
					elevator: false,
					garden: false,
					pool: false,
					sea_selection: 4,
					active: true,
					neighbourhoods: []
				},
				questionnaireValidation: {
					name: '',
					realestate_type: '',
					rooms_no: '',
					price_from: '',
					price_to: '',
					area_from: '',
					area_to: '',
				},
			}
		},
		watch: {
			questionnaire: {
				handler: function () {
					if (this.initialLoadQuestionnaire) {
						this.changesHappened = true;
					}
				},
				deep: true
			},
		},
		computed: {

		},
		methods: {
			questionnaireAddClick(){
				this.changesHappened = true;
				this.questionnairePopupShow = true;
			},
			questionnaireEditClick(id){
				let vm = this;
				this.$APICall('get', 'questionnaires/' + id, {}, (data, success) => {
					if (success) {
						let usableData = JSON.parse(JSON.stringify(data));
						vm.questionnaire = usableData;
						if(vm.questionnaire.sea_1st == true && vm.questionnaire.sea_2nd == false){
							vm.questionnaire.sea_selection =1;
						}
						else if(vm.questionnaire.sea_1st == false && vm.questionnaire.sea_2nd == true){
							vm.questionnaire.sea_selection =2;
						}
						else if(vm.questionnaire.sea_1st == true && vm.questionnaire.sea_2nd == true){
							vm.questionnaire.sea_selection =3;
						}
						else{
							vm.questionnaire.sea_selection =4;
						}
						vm.$nextTick(() => {
							vm.questionnairePopupShow = true;
							vm.initialLoadQuestionnaire = true;
						});
					}
				});
			},
			openQuestionnairePopup() {
				this.questionnairePopupShow = true;
			},
        	closeQuestionnairePopup() {
				this.initialLoadQuestionnaire = false;
				this.changesHappened = false;
				this.questionnairePopupShow = false;
				this.$nextTick(() => {
					this.questionnaire = {
						id: 0,
						name: '',
						realestate_type: null,
						contact_id: '',
						rooms_no: null,
						price_from: null,
						price_to: null,
						area_from: null,
						area_to: null,
						sea_1st: false,
						sea_2nd: false,
						sea_view: false,
						elevator: false,
						garden: false,
						pool: false,
						sea_selection: 4,
						active: true,
						neighbourhoods: []
					};
					this.questionnaireValidation = {
						name: '',
						realestate_type: '',
						rooms_no: '',
						price_from: '',
						price_to: '',
						area_from: '',
						area_to: '',
					}
				});
			},
			cancelQuestionnairePopup() {
				this.closeQuestionnairePopup();
			},
			questionnaireSaveClick() {
				let success = true;
				if(this.questionnaire.name == '' || this.questionnaire.name == null){
					success = false;
					this.questionnaireValidation.name = this.$t('alerts.fieldError');
				} else {
					this.questionnaireValidation.name = '';
				}
				if(this.questionnaire.realestate_type == '' || this.questionnaire.realestate_type == null){
					success = false;
					this.questionnaireValidation.realestate_type = this.$t('alerts.fieldError');
				} else {
					this.questionnaireValidation.realestate_type = '';
				}
				if(this.questionnaire.price_from != '' && this.questionnaire.price_from != null && this.questionnaire.price_to != '' && this.questionnaire.price_to != null){
					if(parseInt(this.questionnaire.price_from) > parseInt(this.questionnaire.price_to)){
						success = false;
						this.questionnaireValidation.price_from = this.$t('alerts.priceError');
						this.questionnaireValidation.price_to = this.$t('alerts.priceError');
					}
					else {
						this.questionnaireValidation.price_from = '';
						this.questionnaireValidation.price_to = '';
					}
				}
				if(this.questionnaire.area_from != '' && this.questionnaire.area_from != null && this.questionnaire.area_to != '' && this.questionnaire.area_to != null){
					if(parseInt(this.questionnaire.area_from) > parseInt(this.questionnaire.area_to)){
						success = false;
						this.questionnaireValidation.area_from = this.$t('alerts.areaError');
						this.questionnaireValidation.area_to = this.$t('alerts.areaError');
					}
					else {
						this.questionnaireValidation.area_from = '';
						this.questionnaireValidation.area_to = '';
					}
				}
				if(this.questionnaire.sea_selection != null){
					if(this.questionnaire.sea_selection == 1){
						this.questionnaire.sea_1st = true;
						this.questionnaire.sea_2nd = false;
					}
					else if(this.questionnaire.sea_selection == 2){
						this.questionnaire.sea_1st = false;
						this.questionnaire.sea_2nd = true;
					}
					else if(this.questionnaire.sea_selection == 3){
						this.questionnaire.sea_1st = true;
						this.questionnaire.sea_2nd = true;
					}
					else{
						this.questionnaire.sea_1st = false;
						this.questionnaire.sea_2nd = false;
						}
				}
				if(this.questionnaire.rooms_no == ''){
					this.questionnaire.rooms_no = null;
				}
				if(this.questionnaire.price_from == ''){
					this.questionnaire.price_from = null;
				}
				if(this.questionnaire.price_to == ''){
					this.questionnaire.price_to = null;
				}
				if(this.questionnaire.area_from == ''){
					this.questionnaire.area_from = null;
				}
				if(this.questionnaire.area_to == ''){
					this.questionnaire.area_to = null;
				}
				if (success) {
					let vm = this;
					let action = 'post';
					let addition = '';
					vm.questionnaire.contact_id = vm.contact.id;
					if (vm.questionnaire.id != 0) {
						action = 'put';
						addition = '/' + vm.questionnaire.id;
					}
					this.$APICall(action, 'questionnaires' + addition, this.questionnaire, (data, success) => {
						if (success) {
							vm.changesHappened = false;
							if (vm.questionnaire.id == 0) {
								vm.$notify(vm.$t('alerts.basicAdd'));
							} else {
								vm.$notify(vm.$t('alerts.basicUpdate'));
							}
							vm.$router.go();
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			},
			back(){
				if (this.initialLoad) {
					this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
						if (result) {
							this.$router.go(-1);
						}
					});
				}
				else{
					this.$router.go(-1);
				}
			},
			save(){
				let vm = this;
				let data = {
					contact: this.contact
				}
				this.$APICall('put', 'contacts/' + this.$route.params.id, data, (data, success) => {
					if (success) {
						vm.$notify(vm.$t('alerts.basicUpdate'));
						vm.$router.go(-1);
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			},
			vtigerLink(){
				window.open(this.vtigerObject.contact.vtiger_link, '_blank');
			},
			match(){
				let routeData = this.$router.resolve('/reports/opportunity-questionnaire/' + this.contact.vtiger_id + '/' + this.questionnaire.id);
				window.open(routeData.href, '_blank');
			}
		},
		mounted() {
			let vm = this;
			this.$APICall('get', 'contacts/vtiger/' + this.$route.params.id, {}, (data, success) => {
				if (success) {
					if(data.contact != null){
						vm.vtigerObject = data;
						vm.$myStore.commit('setBreadcrumbs', [
							{text: this.$t('modules.contacts'), href: '/#/contacts', disabled: false},
							{text:this.$route.params.id +' - '+ vm.vtigerObject.contact.firstname + ' ' + vm.vtigerObject.contact.lastname, href: '/#/contacts/' + this.$route.params.id, disabled: true}
						]);
						this.$APICall('get', 'contacts/' + this.$route.params.id, vm.vtigerObject, (data, success2) => {
							if (success2 && data != undefined) {
								let usableData1 = JSON.parse(JSON.stringify(data['contact']));
								let usableData2 = JSON.parse(JSON.stringify(data['questionnaires_items']));
								let usableData3 = JSON.parse(JSON.stringify(data['questionnaires_total']));
								vm.results = true;
								vm.$nextTick(() => {
									vm.initialLoad = true;
									vm.questionnairePopupShow = false;
								});
								vm.contact = usableData1;
								vm.questionnairesTable.items = usableData2;
								vm.questionnairesTable.total = usableData3;
							}
							else{
								this.$APICall('post', 'contacts/' + this.$route.params.id, vm.vtigerObject, (data, success3) => {
									if (success3) {
										vm.$nextTick(() => {
											this.$APICall('get', 'contacts/' + this.$route.params.id, vm.vtigerObject, (data, success4) => {
											if (success4) {
												let usableData1 = JSON.parse(JSON.stringify(data['contact']));
												let usableData2 = JSON.parse(JSON.stringify(data['questionnaires_items']));
												let usableData3 = JSON.parse(JSON.stringify(data['questionnaires_total']));
												vm.results = true;
												vm.$nextTick(() => {
													vm.initialLoad = true;
												});
												vm.contact = usableData1;
												vm.questionnairesTable.items = usableData2;
												vm.questionnairesTable.total = usableData3;

											}
											else {
												vm.$alert(vm.$t('alerts.basicError'));
											}
											});
										});
									} else {
										vm.$alert(vm.$t('alerts.basicError'));
									}
								});
							}
						});
					}
					else{
						vm.results = false;
					}
				}
				else{
					vm.results = false;
				}
			});
			this.$APICall('get', 'select/languages', {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.languages = usableData;
				}
			});
		}
	}
</script>

<style scoped>
.files-container{
	margin: 5px;
	padding: 5px;
	border: 1px solid rgb(206, 206, 206);
	border-radius: 3px;
	min-height: 130px;
	max-height: 250px;
	overflow-x: auto;
}

.file-tile{
	margin: 2px;
	padding: 2px;
	height: 180px;
	width: 120px;
	text-align: center;
	display: inline-block;
	overflow:hidden;
	word-wrap: break-word;
}

.file-tile:hover{
	background-color: rgb(240, 240, 240);
}

.tile-image{
	margin: 2px;
	padding: 2px;
	height: 100px;
	width: 116px;
	overflow:hidden;
}

.tile-image:hover{
	cursor: pointer;
}

.tile-text{
	margin: 2px;
	padding: 2px;
	height: 30px;
	width: 116px;
	font-size: 10px;
	overflow:hidden;
}
.tile-buttons{
	margin: 2px;
	padding: 2px;
	height: 18px;
	width: 116px;
}

.table{
	font-family: Helvetica, sans-serif;
    font-size: 13px;
    border-collapse: collapse;
	border-radius: 6px;
    width: 100%;
    text-align:center;
	overflow: hidden;
	background-color: #ffffff;
	color: rgb(34, 34, 34);
}

.table td, .table th{
    padding: 6px;
}

.table th{
    font-size: 15px;
    font-weight: bold;
    padding-top: 8px;
    padding-bottom: 8px;
    background-color: #cacaca;
	opacity: 0.9;
}

.table tr:nth-child(even){
    background-color: #e8e8e8;
}

.table td:first-child{
    text-align: center;
}

.table tr:hover{
    background-color: #ddd;
}

.website-error{
	color: rgb(131, 10, 10);
}
</style>
